import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Box, styled, Typography } from '@mui/material';
import * as React from 'react';
import { Link } from 'react-router';
import { SHADOW } from 'styles/theme';
import Flex from 'ui/Flex/Flex';

const StyBox = styled(Box, {
    name: 'StyBox',
    shouldForwardProp: (prop) => prop !== 'shadow',
})<{ shadow?: boolean }>(({ shadow }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 1.5rem',
    height: '78px',
    minHeight: '78px',
    boxShadow: shadow ? SHADOW : 'none',
    backgroundColor: 'white',
    zIndex: 1,
}));

type Props = {
    title: string | React.ReactNode;
    breadcrumbParent?: { label: string; to: string };
    titleActions?: React.ReactNode;
    actions?: React.ReactNode;
    shadow?: boolean;
};

const HeaderLayout = ({
    title,
    breadcrumbParent = undefined,
    titleActions = undefined,
    actions = undefined,
    shadow = true,
}: Props): React.ReactElement => (
    <StyBox shadow={shadow}>
        <Flex alignItems="center" gap={1}>
            {breadcrumbParent && (
                <>
                    <Typography
                        component={Link}
                        to={breadcrumbParent.to}
                        variant="h4"
                        color="primary"
                        sx={{
                            textDecoration: 'none',
                            '&:hover': { textDecoration: 'underline' },
                        }}
                    >
                        {breadcrumbParent.label}
                    </Typography>
                    <NavigateNextIcon />
                </>
            )}
            <Typography
                variant="h4"
                color={breadcrumbParent ? 'inherit' : 'primary'}
            >
                {title}
            </Typography>
            {titleActions}
        </Flex>
        {actions}
    </StyBox>
);

export default React.memo(HeaderLayout);
